import { HttpInterceptorFn } from '@angular/common/http';
import { HttpRequest, HttpHandlerFn, HttpEvent } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, Observable, switchMap, throwError } from 'rxjs';
import { TokenRefreshCoordinatorService } from './token-refresh-coordinator.service';
import { LocalStorageService } from '../localStorage/local-storage.service';

const AUTH_ROUTES = ['/auth/login', '/auth/ad-login', '/auth/refresh', '/auth/logout'];

export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
  const refreshCoordinator = inject(TokenRefreshCoordinatorService);
  const localStorage = inject(LocalStorageService);
  const router = inject(Router);

  // Rotas de auth não passam pelo ciclo de refresh (evita recursão caso a própria
  // chamada de login/refresh/logout falhe com 401). Cada chamada em
  // http-client.service.ts já anexa seu próprio header Authorization via
  // getDefaultHeaders(), então o interceptor não precisa duplicar isso.
  if (AUTH_ROUTES.some((path) => req.url.includes(path))) {
    return next(req);
  }

  return next(req).pipe(
    catchError((error) => {
      if (error.status !== 401) {
        return throwError(() => error);
      }

      const staleBearerToken = String(localStorage.get('bearerToken'));

      return refreshCoordinator.refresh(staleBearerToken).pipe(
        switchMap(({ bearerToken }) => {
          const retriedReq = req.clone({
            setHeaders: { Authorization: `Bearer ${bearerToken}` },
          });
          return next(retriedReq);
        }),
        catchError((refreshError) => {
          localStorage.remove('bearerToken');
          localStorage.remove('refreshToken');
          router.navigate(['/login']);
          return throwError(() => refreshError);
        }),
      );
    }),
  );
};
